<ng-container *ngFor="let component of components$ | async; let i = index">
  <ng-container *ngIf="component">
    <button [class.active]="i === activeTabNum" (click)="select(i)" class="custom-tabs-class">
      {{ component.title | cxTranslate: { param: tabTitleParams[i] | async } | uppercase  }}
    </button>
    <div [class.active]="i === activeTabNum">
      <ng-template [cxOutlet]="component.flexType" [cxOutletContext]="{}">
        <ng-container [cxComponentWrapper]="component" class="custom-description"></ng-container>
      </ng-template>
    </div>
  </ng-container>
  
</ng-container>